// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
// import "../css/AboutSection.css"; // Import CSS file

// const AboutSection = ({ title, description, buttonText, imageUrl, stats = [] }) => {
//   return (
//     <div className="about-container">
//       {/* About Section */}
//       <div className="about-section">
//         {/* Text Content */}
//         <div className="about-text">
//           <h1>{title}</h1>
//           <p>{description}</p>
//           <button className="learn-more">
//             {buttonText} <FontAwesomeIcon icon={faArrowRight} />
//           </button>
//         </div>

//         {/* Image */}
//         <div className="about-image">
//           <img src={imageUrl} alt="About Section" />
//         </div>
//       </div>

//       {/* Stats Section */}
//       {stats.length > 0 && (
//         <div className="stats-grid">
//           {stats.map((stat, index) => (
//             <div key={index} className="stat-item">
//               <h2>{stat.value}</h2>
//               <p>{stat.label}</p>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// AboutSection.defaultProps = {
//   stats: [],
// };

// export default AboutSection;


import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom"; // Import Link for internal navigation
import "../css/AboutSection.css"; // Import CSS file

const AboutSection = ({ title, description, buttonText, buttonLink, imageUrl, stats = [] }) => {
  return (
    <div className="about-container">
      {/* About Section */}
      <div className="about-section">
        {/* Text Content */}
        <div className="about-text">
          <h1>{title}</h1>
          <p>{description}</p>
          {buttonLink ? (
            <Link to={buttonLink} className="learn-more">
              {buttonText} <FontAwesomeIcon icon={faArrowRight} />
            </Link>
          ) : (
            <button className="learn-more" disabled>
              {buttonText} <FontAwesomeIcon icon={faArrowRight} />
            </button>
          )}
        </div>

        {/* Image */}
        <div className="about-image">
          <img src={imageUrl} alt="About Section" />
        </div>
      </div>

      {/* Stats Section */}
      {stats.length > 0 && (
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <h2>{stat.value}</h2>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

AboutSection.defaultProps = {
  stats: [],
};

export default AboutSection;
